import { render, staticRenderFns } from "./CommonModalWithPurchaseOrderInfo.vue?vue&type=template&id=636888ce&lang=pug&"
import script from "./CommonModalWithPurchaseOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithPurchaseOrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithPurchaseOrderInfo.vue?vue&type=style&index=0&id=636888ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports